<template>
  <a
    :href="result.pagePath"
    class="row rounded overflow-hidden mx-0 mb-2 search-result"
  >
    <div class="col-auto bg-newspr p-1 text-center side-icons">
      <FontAwesomeIcon :icon="icons.faNewspaper" class="d-block fa-fw" />
      <SearchResultScore :result="result" />
    </div>
    <div class="col">
      <div class="row">
        <div class="col-12 col-lg p-3 order-2">
          <h3 class="h4 mb-1 d-flex justify-content-between">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span class="text-primary" v-html="title"></span>
            <span class="small">{{ date }}</span>
          </h3>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="small description" v-html="result.descriptionHTML"></div>
        </div>
        <div class="col-12 col-lg-3 p-3 side-image order-1 order-lg-3">
          <SearchResultImage :result="result" :dimensions="customContent" />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createNamespacedHelpers } from 'vuex';

import { formatDate } from '@/src/utilities/formatters';

import SearchResultImage from './SearchResultImage.vue';
import SearchResultScore from './SearchResultScore.vue';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'NewsPRResult',

  components: {
    FontAwesomeIcon,
    SearchResultImage,
    SearchResultScore,
  },

  props: {
    /** @type {import('vue').PropOptions<import('../store/state').SearchResult>} */
    result: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['culture']),

    /** @returns {string} */
    title() {
      return this.result.titleHTML ? this.result.titleHTML : this.result.title;
    },

    /** @returns {{ faNewspaper: import('@fortawesome/fontawesome-common-types').IconDefinition }} */
    icons() {
      return { faNewspaper };
    },

    /** @returns {string} */
    date() {
      return formatDate(this.result.date, this.culture);
    },

    /** @returns {{ imageWidth: number, imageHeight: number }} */
    customContent() {
      return this.result.customContent
        ? JSON.parse(this.result.customContent)
        : { imageWidth: 0, imageHeight: 0 };
    },
  },
};
</script>
